import React, { Component } from "react";
import profile from "../../assets/images/Oval.png";
import { Divider } from "antd";
class TvScreen1 extends Component {
  qpatientdetails = () => (
    <div>
      <div className="row">
        <div className="col-6">
          <span class="row TVDoctor qdoctorFonts qdoctor">
            Dr. Anil Doctor3
          </span>
          <span class="row qdoctorFonts qdoctorProfq ml-5">Cardiologist</span>
        </div>
        <span class="col-3 TVCurrent qdoctorFonts qdoctorProfq mt-3">
          00129
        </span>
        <span class="col-3 TVNext qdoctorFonts qdoctorProfq mt-3">01120</span>
      </div>
      {/* <div class="Line" /> */}
      <Divider />
    </div>
  );
  render() {
    return (
      <div className="row tvScreen1">
        <div className="col-lg-4 col-md-4 doctorsDetailsDiv">
          <img alt="" src={profile} class="qdoctorImg" />
          <span class="qdoctorName">Dr. Ivan Palmer</span>
          <span class="qdoctorProf">Cardiologist</span>
          <span class="qdoctorExp">Experience: 20 Years</span>
          <div className="row qroom_status">
            <span class="qdoctorRoom">
              Room No:
              <span class="qdoctor-text-style-1">12</span>
            </span>
            <span class="qdoctorStatus">
              Status:
              <span class="qdoctor-text-style-1">In</span>
            </span>
          </div>
          <span class="row qdoctorTimings">Timings:</span>
          <div className="row qdocTimings">
            <span class="qdoctorTime">10:00AM-02:00PM</span>
            <span class="qdoctorTime">03:00PM-10:00PM</span>
          </div>
        </div>
        <div className="col-lg-7 col-md-4 patientQ">
          <div className="patientQHeader">
            <span class="col-6 patientQHeaderTitles docTitle">Doctor</span>
            <span class="col-3 patientQHeaderTitles">Current</span>
            <span class="col-3 patientQHeaderTitles">Next</span>
          </div>
          <div className="patientQDetails">
            {this.qpatientdetails()}
            {this.qpatientdetails()}
            {this.qpatientdetails()}
            {this.qpatientdetails()}
            {this.qpatientdetails()}
            {this.qpatientdetails()}
            {this.qpatientdetails()}
            {this.qpatientdetails()}
          </div>
        </div>
      </div>
    );
  }
}
export default TvScreen1;
